import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';
import { VenueRegistrationQuestionTypes } from '../../formQuestions';
import EventHandler from '../../../../utils/dom/event-handler';
import { EDIT_CARD_INFO_REMOVED_EVENT } from '../../../../webComponents/EditCardInfo';

class TeamInformationWelfareOfficer extends VenueRegistrationFormModal {
	constructor() {
		super({
			wrapperSelector: '.p-team-information',
			sectionWrapperSelector: '.p-team-information-wrapper',
			modalSelector: '#js-team-info-welfare-officer-form-modal',
			triggerSelectors: ['.js-team-info-add-welfare-officer'],
			editTriggerSelectors: ['.js-team-info-edit-welfare-officer'],
			stepsEndpointAttr: 'welfare-officer-steps-endpoint',
			submitEndpointAttr: 'welfare-officer-submit-endpoint',
			logPrefix: 'TeamInformationWelfareOfficer'
		});
	}

	init() {
		super.init();
		if (!this._wrapper) {
			return;
		}

		EventHandler.on(this._wrapper, EDIT_CARD_INFO_REMOVED_EVENT, () => {
			window.location.reload();
		});
	}

	getActiveContactSearchQuestion() {
		return this.formGenerator?.questions?.find(
			(question) =>
				question.questionType === VenueRegistrationQuestionTypes.AddNewContact && question.visible
		);
	}

	getSelectedContact() {
		const fromSearch = this.getActiveContactSearchQuestion()?.ref?.getSelectedContact?.();
		if (fromSearch?.displayName || fromSearch?.name || fromSearch?.id) {
			return fromSearch;
		}

		return this.selectedContact || {};
	}

	clearSelectedContact() {
		const searchQuestions =
			this.formGenerator?.questions?.filter(
				(question) => question.questionType === VenueRegistrationQuestionTypes.AddNewContact
			) || [];

		searchQuestions.forEach((question) => {
			question.ref?.clearSelectedContact?.({ skipEmit: true });
		});
		this.selectedContact = null;
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: this.totalSteps,
			formType: FormTypes.StepForm,
			hasSeparator: true,
			isBackButtonEnabled: true,
			isRenderDependentQuestion: true,
			conditionalStepsVisiblity: true,
			exitButtonLabel: 'Exit',
			exitButtonHandler: () => {
				this.closeFormModal();
			},
			exitButtonClasses: 'lta-form-generator__form-exit-button--underlined',
			nextStepButtonLabel: 'Save and continue',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue'
			},
			getSelectedContact: () => this.getSelectedContact(),
			getContactId: () => this.getSelectedContact()?.id || this.contactId,
			onSelectedContactChange: (contact) => {
				this.selectedContact = contact || null;

				if (contact) {
					const activeId = this.getActiveContactSearchQuestion()?.id;
					this.formGenerator?.questions
						?.filter(
							(question) =>
								question.questionType === VenueRegistrationQuestionTypes.AddNewContact &&
								question.id !== activeId
						)
						.forEach((question) => question.ref?.clearSelectedContact?.({ skipEmit: true }));
				}
			},
			onSelectedContactReset: () => {
				this.clearSelectedContact();
				if (this.formGenerator?.currentStep > 1) {
					this.formGenerator.backButtonClickHandler();
				}
			}
		};
	}
}

VenueRegistrationFormModal.boot(TeamInformationWelfareOfficer);

export default TeamInformationWelfareOfficer;
